// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-image[data-v-9d98158a]{box-shadow:0 0 8px rgba(0,0,0,.2);width:100px;height:100px}.form_box .from[data-v-9d98158a]{display:flex}.form_box .from .form_left[data-v-9d98158a]{width:45%}.form_box .from .form_right[data-v-9d98158a]{width:45%;margin-left:5%;max-height:70vh;overflow-y:auto}.form_box .el-input-number[data-v-9d98158a]{width:100%}", ""]);
// Exports
module.exports = exports;
